import { render, staticRenderFns } from "./DownloadStudent.vue?vue&type=template&id=258e71a0&scoped=true&"
import script from "./DownloadStudent.vue?vue&type=script&lang=js&"
export * from "./DownloadStudent.vue?vue&type=script&lang=js&"
import style0 from "./DownloadStudent.vue?vue&type=style&index=0&id=258e71a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258e71a0",
  null
  
)

export default component.exports